import React, { Component } from 'react';
import SequenceButtonsContainer from '../bottomBar/SequenceButtonsContainer.js';
import DocLink from './DocLink.js';

class RollRecordQuantizeDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                The <b>Play</b>, <b>Record</b>, <b>Roll</b> and <b>Quantized</b> buttons are at the bottom of the sequencer.
              </p>
                <SequenceButtonsContainer sequencerEngine={this.props.sequencerEngine}/>
              <p>
                <b>Play</b>: Play/stop the track.
                <ul>
                  <li>Keyboard Shortcut: <b>spacebar</b></li>
                </ul>
              </p>
                <p>
                <b>Record</b>: When recording, any triggers you make via your
            computer-keyboard or MIDI interface will be recorded into the current pattern.
                <ul>
                <li>Keyboard Shortcut: <b>. (period)</b></li>
                </ul>
              </p>
                <p>
                <b>Roll</b>: When rolling, any triggers you make via your
            computer-keyboard or midi-interface get triggered at a constant rate, following
                  the <b>resolution</b> of the sequencer. For more information on rolling,
                  go to the <DocLink name="Rolling and Resolution" goToLink={this.props.goToLink}/> documentation page.
                <ul>
                <li>Keyboard Shortcut: <b>' (single forward quote)</b></li>
                </ul>
                </p>
                <p>
                <b>Quantized</b>: When quantized, any triggers recorded are
            snapped to the grid, at the <b>resolution</b> of the sequencer.
                When unquantized, the triggers get recorded exactly as played.
                </p>
              <p>
            <b>Resample</b>: Records the output of the entire project for one loop and saves the recording as a new track. For more information on resampling, go to the <DocLink name="Resampling" goToLink={this.props.goToLink}/> documentation page.
              </p>
           </div>
        );
    }
}

export default RollRecordQuantizeDocumentation;
